module.exports = __webpack_public_path__ + "img/logo.ebea7c0c.svg";